/*
  KID-151: carrossel de colecoes em leque (sections/kc-carrossel-colecoes.liquid).
  Aqui so se decide qual card e o ativo e a posicao de cada um (data-pos de -3
  a 3, em loop); deslocamento, escala e veu ficam no CSS. Setas, pontos, clique
  no card lateral, arrastar no celular e teclado navegam; "Comprar" acompanha
  a colecao ativa.
*/
if (!customElements.get('kc-carrossel-colecoes')) {
  class KcCarrosselColecoes extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.total = this.items.length;
      if (!this.total) return;

      this.atual = 0;
      this.botao = this.querySelector('[data-shop]');
      this.pontos = Array.from(this.querySelectorAll('[data-dot]'));
      this.trilho = this.querySelector('.kc-ccol__track');

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.ir(this.atual - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.ir(this.atual + 1));
      this.pontos.forEach((ponto) => {
        ponto.addEventListener('click', () => this.ir(Number(ponto.dataset.dot)));
      });

      // card lateral: o clique traz ele para o centro em vez de abrir a colecao
      this.items.forEach((item, indice) => {
        item.addEventListener('click', (evento) => {
          if (this.arrastou || indice !== this.atual) {
            evento.preventDefault();
            if (!this.arrastou) this.ir(indice);
          }
        });
      });

      this.addEventListener('keydown', (evento) => {
        if (evento.key === 'ArrowLeft') this.ir(this.atual - 1);
        if (evento.key === 'ArrowRight') this.ir(this.atual + 1);
      });

      // editor do tema: ao selecionar um bloco, ele vem para o centro
      this.aoSelecionarBloco = (evento) => {
        const indice = this.items.findIndex((item) => item === evento.target || item.contains(evento.target));
        if (indice > -1) this.ir(indice);
      };
      document.addEventListener('shopify:block:select', this.aoSelecionarBloco);

      this.ligarArraste();
      this.ligarAutoplay();
      this.posicionar();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('shopify:block:select', this.aoSelecionarBloco);
    }

    // distancia circular do card ate o ativo, entre -total/2 e total/2
    distancia(indice) {
      let d = (indice - this.atual) % this.total;
      if (d > this.total / 2) d -= this.total;
      if (d < -this.total / 2) d += this.total;
      return d;
    }

    posicionar() {
      this.items.forEach((item, indice) => {
        const d = this.distancia(indice);
        const pos = Math.max(-3, Math.min(3, d));
        item.dataset.pos = String(pos);
        const visivel = Math.abs(d) <= 2;
        item.setAttribute('aria-hidden', visivel ? 'false' : 'true');
        const link = item.querySelector('a');
        if (link) link.tabIndex = d === 0 ? 0 : -1;
      });
      const ativo = this.items[this.atual];
      if (this.botao && ativo) this.botao.href = ativo.dataset.url;
      this.pontos.forEach((ponto, indice) => {
        ponto.setAttribute('aria-current', indice === this.atual ? 'true' : 'false');
      });
    }

    ir(indice) {
      this.atual = ((indice % this.total) + this.total) % this.total;
      this.posicionar();
      this.reiniciarAutoplay();
    }

    ligarArraste() {
      let inicioX = 0;
      let inicioY = 0;
      let ativo = false;
      this.trilho.addEventListener('pointerdown', (evento) => {
        ativo = true;
        this.arrastou = false;
        inicioX = evento.clientX;
        inicioY = evento.clientY;
      });
      this.trilho.addEventListener('pointerup', (evento) => {
        if (!ativo) return;
        ativo = false;
        const dx = evento.clientX - inicioX;
        const dy = evento.clientY - inicioY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.arrastou = true;
          this.ir(this.atual + (dx < 0 ? 1 : -1));
          // o click que vem logo depois do arraste nao deve abrir a colecao
          setTimeout(() => (this.arrastou = false), 0);
        }
      });
      this.trilho.addEventListener('pointercancel', () => (ativo = false));
      // sem isso o navegador comeca a arrastar o link/imagem e cancela o gesto
      this.trilho.addEventListener('dragstart', (evento) => evento.preventDefault());
    }

    ligarAutoplay() {
      this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tempo = Math.max(3, Number(this.dataset.speed) || 5) * 1000;
      if (!this.autoplay) return;
      const pausar = () => {
        this.pausado = true;
        clearInterval(this.timer);
      };
      const voltar = () => {
        this.pausado = false;
        this.reiniciarAutoplay();
      };
      this.addEventListener('mouseenter', pausar);
      this.addEventListener('focusin', pausar);
      this.addEventListener('mouseleave', voltar);
      this.addEventListener('focusout', voltar);
      this.reiniciarAutoplay();
    }

    reiniciarAutoplay() {
      if (!this.autoplay || this.pausado) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (!document.hidden) this.ir(this.atual + 1);
      }, this.tempo);
    }
  }

  customElements.define('kc-carrossel-colecoes', KcCarrosselColecoes);
}
